import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Box, Grid, Heading, Stack } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { ContactUsWithSubjectsExtended } from '@sitecore/types/manual/be/ContactUsWithSubjectsExtended';

const EmailOurSupportBanner: FC = () => {
  const { fields } = useContent<ContactUsWithSubjectsExtended>();

  return (
    <Box backgroundColor="backgroundSecondary" paddingY={16} paddingX={10}>
      <Grid columns={{ initial: 1, lg: 8 }}>
        <Grid.Item gridColumn={{ initial: '1/-1', md: '2/-4' }}>
          <Stack direction="column" gap={4}>
            <Heading size="XL" as="h2">
              {fields.banner.title.value}
            </Heading>

            <RichText html={fields.banner.description.value} />
          </Stack>
        </Grid.Item>
      </Grid>
    </Box>
  );
};

export default EmailOurSupportBanner;
